import { FC } from 'react';

import { ReleaseNoteBoard } from '@shared/releaseNotes/ReleaseNoteBoard';

import {
  SELLER_RELEASE_NOTE_CHANNELS,
  SELLER_RELEASE_NOTE_LAST_SEEN_KEY,
} from '../hooks/useSellerReleaseNotes';
import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

/**
 * 화환 판매자 콘솔의 업데이트 소식 — 관리자 콘솔과 같은 화면을 화환팀 채널만 걸러서 쓴다.
 * 원본은 docs/releases/notes/{배포일}.mari-seller.md (scripts/genReleaseNotes.js가 번들에 심음).
 */
const SellerReleaseNotePage: FC = function SellerReleaseNotePage() {
  useSellerTopNavHook('업데이트');

  return (
    <ReleaseNoteBoard
      channels={SELLER_RELEASE_NOTE_CHANNELS}
      storageKey={SELLER_RELEASE_NOTE_LAST_SEEN_KEY}
      searchPlaceholder="기능·내용 검색 (예: 현금영수증, 입금대기)"
    />
  );
};

export default SellerReleaseNotePage;
